import { type QueryHookOptions, useQuery } from "@apollo/client";
import { EmailCampaignOptionsQuery } from "../graphql/queries";
import type {
  EmailCampaignOptionsQueryType,
  EmailCampaignOptionsQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useEmailCampaignOptionsQuery = (
  options?: QueryHookOptions<
    EmailCampaignOptionsQueryType,
    EmailCampaignOptionsQueryVariablesType
  >
) =>
  useQuery<
    EmailCampaignOptionsQueryType,
    EmailCampaignOptionsQueryVariablesType
  >(EmailCampaignOptionsQuery, options);
